import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Body = styled(BaseGrid)``

export const ButtonBox = styled(({ children, ...props }) => <div {...props}>{children}</div>)`
  ${props => props.theme.breakpoints.down('sm')} {
    display: flex;
    justify-content: center;
  }
`

export const Column = styled(({ ...props }) => <BaseGrid {...props} item />)`
  &.centerOnTablet {
    align-items: center;
    display: flex;
    justify-content: center;
    text-align: center;
  }
`

export const DialogButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
`

export const DialogContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
`

export const DialogSubContainer = styled('div')`
  margin: 16px 0 0;
  text-align: center;
  width: '100%';
`

export const DialogQuestionsContainer = styled('div')``

export const InstitutionsList = styled('ul')`
  flex: 1;
  padding-left: 25px;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 0;
    padding-left: 19px;
  }
`

export const InstitutionsListContainer = styled('div')`
  align-self: stretch;
  display: flex;
  font-family: ${props => props.theme.typography.body2};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  gap: 10px;
  justify-content: space-between;
  line-height: 18px;
  margin-top: 16px;
  text-align: left;

  ${props => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: 0;
    margin-top: 27px;
  }
`

export const InstitutionsListItem = styled('li')`
  margin-bottom: 0;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand[props.color]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: ${props => (props.underline ? 'underline' : 'inherit')};

  &:hover {
    color: ${({ color, theme }) => {
      switch (color) {
        case 'primary':
          return theme.palette.blue[35]
        case 'black2':
          return theme.palette.brand.black3
        default:
          return 'inherit'
      }
    }};
  }
`

export const List = styled('ul')`
  margin-top: 16px;
  padding-left: 25px;
`

export const ListItem = styled('li')`
  color: ${props => props.theme.palette.brand.black2};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 8px;
  text-decoration-line: underline;
`

export const Root = styled('div')`
  margin: 0;
  width: 100%;
`

export const Section = styled(({ children, fontSize, lineHeight, width, marginTop, ...props }) => (
  <section {...props}>{children}</section>
))`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.fontSize};
  font-style: normal;
  font-weight: 400;
  line-height: ${props => props.lineHeight};
  margin-top: ${props => props.marginTop || '28px'};
  width: ${props => props.width || '100%'};

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: left;
  }

  .MuiAlert-message > span {
    color: ${props => props.theme.palette.brand.black1};
  }
`

export const Strong = styled('b')`
  font-weight: 700;
`

export const Title = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-style: normal;
  font-size: 34px;
  font-weight: 700;
  line-height: 38px;

  ${props => props.theme.breakpoints.down('lg')} {
    font-size: 27px;
    font-weight: 700;
    line-height: 31px;
  }
  ${props => props.theme.breakpoints.down('sm')} {
    font-size: 22px;
    line-height: 26px;
    text-align: left;
  }
`

export const WelcomeImage = styled('img')`
  margin-top: 25px;

  ${props => props.theme.breakpoints.up('md')} {
    width: 85%;
  }
  ${props => props.theme.breakpoints.down('md')} {
    width: 90%;
  }
  ${props => props.theme.breakpoints.down('sm')} {
    display: none;
  }
  ${props => props.theme.breakpoints.down('xs')} {
    display: none;
  }
`
